<template>
  <div>
    <transition name="fade">
      <div class="content__toast" v-if="showCopyToastLayer && item.url !== 'Direct' && item.url !== 'etc'" :class="{'center': type === 'center'}">
        <span>{{ $t('common.trackingCode.copied') }}</span>
        <i class="icon icon--check-green-size16"></i>
      </div>
    </transition>
    <p class="flow_txt " :class="{'hover': urlHover && item.url !== 'Direct' && item.url !== 'etc', 'center': type === 'center'}" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
      <button type="button" v-if="item.url !== 'Direct' && item.url !== 'etc'" class="outlink icon icon--link-size16"
              @click="$emit('onUrlLink', item.url)"></button>
      <span class="url ellipsis">
        <template v-if="item.stepData"  >
          <span class="txt_desc">
            Step {{ item.stepData.step }}
          </span>
          <span class="step-name">{{ item.stepData.name }}</span>
          <span class="seperator"></span>
        </template>
        <span class="url-detail"  @click="copy($event)">
          {{ item.url }}
        </span>
        <span class="real-url" >
          {{getUrlByType}}
        </span>
      </span>
    </p>
  </div>

</template>

<script>
import { getConversionUrl } from '@/libs/analytics-helper'
import { mapState } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: false
    },
    type: {
      type: String,
      default: '',
      required: false
    },
    option: {
      type: String,
      default: 'refer',
      required: false
    }
  },
  watch: {

  },
  data () {
    return {
      urlHover: false,
      showCopyToastLayer: false
    }
  },
  computed: {
    ...mapState([
      'applyData'
    ]),
    getUrlByType () {
      if (this.type === 'center') {
        return this.item.url
      } else {
        if (this.option === 'refer') {
          return 'http://' + this.item.url
        } else {
          return getConversionUrl(this.item.url, this.applyData.hostname)
        }
      }
    }
  },
  methods: {
    onMouseEnter () {
      if (this.item.url !== 'Direct') {
        this.urlHover = true
      }
    },
    onMouseLeave () {
      this.urlHover = false
      this.showCopyToastLayer = false
      let sel = window.getSelection()
      sel.removeAllRanges()
    },
    copy (event) {
      const clickElem = event.target
      const targetElem = clickElem.parentNode.querySelector('.real-url')

      const content = targetElem.innerText

      const userAgent = navigator.userAgent.toLowerCase()
      let isEdge = false
      if ((userAgent.indexOf('chrome') !== -1) && (userAgent.indexOf('edg') !== -1)) {
        isEdge = true
      }

      if (targetElem) {
        if (isEdge) {
          const el = document.createElement('textarea')
          el.value = content
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
          if (selected) {
            document.getSelection().removeAllRanges()
            document.getSelection().addRange(selected)
          }
        } else {
          let range = document.createRange()
          range.setStartBefore(targetElem)
          range.setEndAfter(targetElem)
          let sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(range)
          document.execCommand('copy', false)

          range.setStartBefore(clickElem)
          range.setEndAfter(clickElem)
          sel.removeAllRanges()
          sel.addRange(range)
        }

        this.showCopyToastLayer = true
        setTimeout(() => {
          this.showCopyToastLayer = false
        }, 5000)
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.fade-leave-active,
.fade-enter-active {
  transition: opacity 0.2s ease;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.real-url {
  position: absolute;
  left: -999999px;
}

.content__toast {
  display: inline-block;
  height: 32px;
  border-radius: 6px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
  background-color: rgba(0,0,0,0.85);
  position: absolute;
  top: -30px;
  left: 21px;

  padding-left: 12px;
  padding-right: 45px;
  &.center {

    top: 10px;
    left: 0px;
  }
  span {
    font-size: 13px;
    font-weight: 600;
    color: #57ab00;
    line-height: 32px;
  }
  i {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }
}

.outlink {
  display: none;
}

.flow_txt {
  position: absolute;
  margin: 8px 20px 0 26px;
  color: #444;
  font-weight: 600;
  line-height: 21px;
  width: 100%;
  max-width: 263px;
  height: 22px;

  .txt_desc {
    color: #289eef;
  }

  .step-name {
    color: #333;
    font-weight: 500;
  }

  .seperator {
    position: relative;
    display: inline-block;
    top: 1px;
    width: 1px;
    height: 10px;
    background-color: #d7d7d7;
    margin: 0 6px;
  }

  &.hover {

  }

  .url {
    float: left;

    font-weight: 500;
    color: #444;
    font-size: 14px;
    line-height: 22px;
    margin-top: -2px;
    display: inline-block;
    width: 263px;
    &.nolink {
      padding-left: 21px;
    }
  }

  &.hover {
    max-width: 561px;
    width: inherit;
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    padding-right: 6px;
    z-index: 8888;
    margin-left: 20px;
    margin-top: 6px;

    & > .url {
      width: inherit;
      float: left;
      max-width: 536px;
      margin-left: 21px;
      font-size: 12px;
      height: 22px;
      line-height: 25px;
      margin-top: -1px;
      padding-left: 8px;
      color: #555;
    }

    & > .outlink {
      margin: 3px 0 0 3px;
      display: inline-block;
      float: left;
      position: absolute;
      top: 0px;
      left: 0px;
      background-image: url(../../assets/img/icon_link_blue_size16.svg);
    }
  }

  &.center {
    padding-left: 5px;
    //width: 223px;

    margin: 0px;

    & > .outlink {
      left: 3px;
    }

    & > .url {
      font-size: 12px;
      width: 226px;
      margin-top: -1px;
    }

    &.hover {
      padding-right: 6px;
      & > .url {
        width: inherit;
        margin-left: 17px;
      }
    }
  }
}

</style>
